import React, { useEffect } from "react";
import { navigate } from "gatsby";
import { useExploreInDelhiQuery } from "./graphql/query";
import AirportSec from "./components/AirportSec.jsx";
import TravelSec from "./components/TravelSec.jsx";
import Highlight from "./components/Highlight.jsx";
import Attractions from "./components/Attractions.jsx";
import Layovers from "./components/Layovers.jsx";
import "./explore.css";
import NewCommonBanner from "../../components/common/banner/NewCommonBanner.jsx";
import CommonTextBelowBanner from "../../components/common/banner/CommonTextBelowBanner.jsx";
import NewStyleBanner from "../../components/common/banner/NewStyleBanner.jsx";
import NotFoundPage from "../../pages/404";
import { hasBannerSectionData } from "../../utils/bannerData";

const ExploreInDelhiTemplate = ({ keyword }) => {
  const ExploreInDelhiQuery = useExploreInDelhiQuery(keyword);

  const {
    banner_section,
    bottom_text,
    delhi_attractions,
    near_the_airport,
    short_layovers,
    travel_tips_section,
  } = ExploreInDelhiQuery || {};
  const hasBannerData = hasBannerSectionData(banner_section);

  useEffect(() => {
    if (!hasBannerData) {
      navigate("/404/", { replace: true });
    }
  }, [hasBannerData]);

  return (
    <section>
      <NewStyleBanner banner_section={banner_section} />
      <CommonTextBelowBanner data={banner_section} size={true} />
      <AirportSec data={near_the_airport} />
      <Attractions data={delhi_attractions} />
      <Layovers data={short_layovers} />
      <TravelSec data={travel_tips_section}></TravelSec>
      <Highlight data={bottom_text} />
    </section>
  );
};

export default ExploreInDelhiTemplate;
